// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  --width: 100%;
}

.segment {
  --padding-end: 2px;
  --padding-start: 2px;
}

.theme-cover {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  color: var(--ion-text-color);
  align-items: center;
}

.staff-avatar {
  vertical-align: middle;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

ion-menu ion-list ion-item {
  font-weight: 600;
  font-size: 1rem;
  color: #2D3244;
  --detail-icon-color: #000000;
  --detail-icon-opacity: 1;
  --detail-icon-font-size: 1.5rem;
  height: 40px;
  --inner-padding-bottom: 8px;
}

.close-button {
  font-size: 30px;
  color: var(--ion-text-color);
  position: absolute;
  right: 7.5%;
  top: calc(var(--ion-safe-area-top) + 1rem);
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;AACF;;AAGA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAKI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;EACA,wBAAA;EACA,+BAAA;EACA,YAAA;EACA,2BAAA;AAFN;;AAOA;EACE,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;AAJF","sourcesContent":[".menu {\n  --width: 100%;\n}\n\n.segment {\n  --padding-end: 2px;\n  --padding-start: 2px;\n}\n\n.theme-cover {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  color: var(--ion-text-color);\n  align-items: center;\n}\n\n\n.staff-avatar {\n  vertical-align: middle;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n}\n\nion-menu{\n  ion-list{\n    ion-item{\n      font-weight: 600;\n      font-size: 1rem;\n      color: #2D3244;\n      --detail-icon-color: #000000;\n      --detail-icon-opacity: 1;\n      --detail-icon-font-size: 1.5rem;\n      height: 40px;\n      --inner-padding-bottom: 8px;\n    }\n  }\n}\n\n.close-button{\n  font-size: 30px;\n  color: var(--ion-text-color);\n  position: absolute;\n  right: 7.5%;\n  top: calc(var(--ion-safe-area-top) + 1rem);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
